import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MobileAppPaymentErrorComponent } from './payment-error/mobile-app-payment-error.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    NgbModule,
    NgxSpinnerModule
  ],
  exports: [
    CommonModule
  ],
  declarations: [
    MobileAppPaymentErrorComponent
  ]
})
export class MobileAppModule {}



// WEBPACK FOOTER //
// ./src/app/views/mobile-app/mobile-app.module.ts